import type { OnePagerData } from "../types";
import { NavigationReady } from "@softmax/web-features/navigation/markers";
import { LeaderboardUnavailable } from "./leaderboard-unavailable";
import { plainName } from "../../lib/program-names";
import s from "../onepager.module.css";

export function BoardRows({
  data,
  path,
  terminalFailure,
  onRetry,
  pending,
}: {
  readonly data: Pick<OnePagerData, "boardStatus" | "board" | "mineBelow">;
  readonly path: string;
  readonly terminalFailure: boolean;
  readonly onRetry: () => void;
  readonly pending: boolean;
}) {
  const { boardStatus, board, mineBelow } = data;

  if (boardStatus === "unavailable")
    return (
      <LeaderboardUnavailable
        path={path}
        terminalFailure={terminalFailure}
        onRetry={onRetry}
        pending={pending}
      />
    );

  if (boardStatus === "unpublished")
    return (
      <p className={s.empty}>
        <NavigationReady stage="content" path={path} />
        Leaderboard not published yet.
      </p>
    );

  if (board.length === 0)
    return (
      <p className={s.empty}>
        <NavigationReady stage="content" path={path} />
        No ranked cogents yet. The first round ranks everyone who released a
        program.
      </p>
    );

  return (
    <>
      <NavigationReady stage="content" path={path} />
      <ol className={s.board}>
        {[...board, ...(mineBelow ? [mineBelow] : [])].map((row) => (
          <li
            key={`${row.rank}-${row.cogent}`}
            className={s.boardRow}
            data-mine={row.mine || undefined}
            data-below={row === mineBelow || undefined}
          >
            <span className={s.rank}>
              <span className={s.srOnly}>Rank </span>
              {row.rank}
            </span>
            <span className={s.who}>
              <span className={s.cogentName}>{row.cogent}</span>
              {row.owner ? <span className={s.owner}>{row.owner}</span> : null}
            </span>
            <span className={s.program}>
              {row.program ? plainName(row.program) : ""}
            </span>
            <span className={s.score}>
              <span className={s.srOnly}>Score </span>
              {row.score.toFixed(1)}
            </span>
          </li>
        ))}
      </ol>
    </>
  );
}
